import React, { lazy } from "react";
const LegalsPage = lazy(() => import("shared/pages/LegalsPage"));
const LegalsPageEdit = lazy(() => import("shared/pages/LegalsPage/LegalsPageEdit"));
const LegalsAdminPage = lazy(() => import("shared/pages/LegalsPage/LegalsAdminPage"));

const mediiiaLegalRoutes = [
  { path: '/legals/admin', exact: true, isPrivate: true, component: LegalsAdminPage },
  { path: '/legals/create', exact: true, isPrivate: true, component: LegalsPageEdit },
  { path: '/legals/edit/:name?', exact: true, isPrivate: true, component: LegalsPageEdit },
  { path: '/legals/edit/:name?/:version?', exact: true, isPrivate: true, component: LegalsPageEdit },
  { path: '/legals/view/:name?/:version?', exact: true, component: LegalsPageEdit },
  { path: '/legals/:name?', exact: true, component: LegalsPage },
];

export default mediiiaLegalRoutes;
import React, { lazy } from "react";
const LegalsPage = lazy(() => import("shared/pages/LegalsPage"));
const LegalsPageEdit = lazy(() => import("shared/pages/LegalsPage/LegalsPageEdit"));
const LegalsAdminPage = lazy(() => import("shared/pages/LegalsPage/LegalsAdminPage"));

const mediiiaLegalRoutes = [
  { path: '/legals/admin', exact: true, isPrivate: true, component: LegalsAdminPage },
  { path: '/legals/create', exact: true, isPrivate: true, component: LegalsPageEdit },
  { path: '/legals/edit/:name?', exact: true, isPrivate: true, component: LegalsPageEdit },
  { path: '/legals/edit/:name?/:version?', exact: true, isPrivate: true, component: LegalsPageEdit },
  { path: '/legals/view/:name?/:version?', exact: true, component: LegalsPageEdit },
  { path: '/legals/:name?', exact: true, component: LegalsPage },
];

export default mediiiaLegalRoutes;
